import { gate } from 'hub-http/gates';
import { Suspense, lazy } from 'react';
import { AccordionResponseSectionTypename, ActionsResponseSectionTypename, CustomComponentResponseSectionTypename, ArtifactCardResponseSectionTypename, AskQuestionResponseSectionTypename, AvatarCardResponseSectionTypename, CalendarConnectResponseSectionTypename, CardResponseSectionTypename, CardWrapperResponseSectionTypename, ChipsCardResponseSectionTypename, CollaborationResponseSectionTypename, CompanyOverviewResponseSectionTypename, ComposableCardResponseSectionTypename, ConfirmationResponseSectionTypename, ContextItemResponseSectionTypename, CrmCardResponseSectionTypename, DataChangeResponseSectionTypename, DataTableResponseSectionTypename, DataTableResponseSectionV2Typename, DenseListResponseSectionTypename, DraftEmailResponseSectionTypename, EmailDraftCardResponseSectionTypename, FileAttachmentResponseSectionTypename, FilterBranchResponseSectionTypename, GridResponseSectionTypename, HtmlCardResponseSectionTypename, HtmlTextResponseSectionTypename, HtmlWithChildrenResponseSectionTypename, ImageGridResponseSectionTypename, InlineCitationResponseSectionTypename, LlmResponseSectionTypename, MediaPreviewResponseSectionTypename, MediaPreviewResponseSectionV2Typename, MeetingCardResponseSectionTypename, MeetingRecapActionDataResponseSectionTypename, MeetingResponseSectionTypename, MetricCardResponseSectionTypename, NewsListCardResponseSectionTypename, PlainTextResponseSectionTypename, ReportResponseSectionTypename, SourcesListResponseSectionTypename, StepListResponseSectionTypename, SupportHandoffResponseSectionTypename, TabResponseSectionTypename, ThoughtResponseSectionTypename, TimelineCardResponseSectionTypename, UnstyledImageResponseSectionTypename, UserChatResponseSectionTypename, InlineAcademyVideoResponseSectionTypename, MeetingPrepActionDataResponseSectionTypename, VisualizationResponseSectionTypename, ScheduledPromptResponseSectionTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
import { onboardingRegistryEntry } from 'breeze-onboarding-components/js/registry';
import { marketplaceInstallRegistry } from 'marketplace-embed-ba/js/registry';
import { agentHubRegistryEntry } from './custom-component/agentHub/registry';
import { workflowsRegistryEntry } from './custom-component/workflows/registry';
import { brandedStyleGenerationRegistryEntry } from './custom-component/brandedStyleGeneration/registry';
import { lockedFeatureUpgradeRegistry } from 'trial-components-library/breeze/lockedFeatureUpgradeRegistry';
import { unifiedAuthBreezeRegistryEntry } from 'ui-universal-auth/breezeRegistry';
import { dataIntegrationsBreezeRegistryEntry } from 'data-integrations-breeze/breezeRegistry';
import { convertFieldValueAvroToJson } from 'rpc-client-utils';
import CustomComponentFallback from './custom-component/CustomComponentFallback';
import { registerComponentRegistry, resolveComponent } from './custom-component/customComponentRegistry';
import ErrorBoundary from '../../components/error/ErrorBoundary';
import { resolveExternalSectionFormatter } from './sectionFormatterRegistry';
import LoadingSection from './LoadingSection';
import { jsx as _jsx } from "react/jsx-runtime";
const LazyHtmlSectionFormatter = /*#__PURE__*/lazy(() => import('./HtmlSectionFormatter'));
const LazyTextWithTokensSectionFormatter = /*#__PURE__*/lazy(() => import('./TextWithTokenSectionFormatter'));
const LazyDataTableSectionFormatter = /*#__PURE__*/lazy(() => import('./DataTableSectionFormatter'));
const LazyDataTableSectionFormatterV2 = /*#__PURE__*/lazy(() => import('./DataTableSectionFormatterV2'));
const LazyMediaSectionFormatter = /*#__PURE__*/lazy(() => import('./MediaSectionFormatter'));
const LazyThoughtSectionFormatter = /*#__PURE__*/lazy(() => import('./ThoughtsSectionFormatter'));
const LazyActionSectionFormatter = /*#__PURE__*/lazy(() => import('./ActionSectionFormatter'));
const LazyAccordionSectionFormatter = /*#__PURE__*/lazy(() => import('./AccordionSectionFormatter'));
const LazyCalendarConnectSectionFormatter = /*#__PURE__*/lazy(() => import('./CalendarConnectSectionFormatter'));
const LazyCardSectionFormatter = /*#__PURE__*/lazy(() => import('./CardSectionFormatter'));
const LazyMarkdownSectionFormatter = /*#__PURE__*/lazy(() => import('./MarkdownSectionFormatter'));
const LazyConfirmationSectionFormatter = /*#__PURE__*/lazy(() => import('./ConfirmationSectionFormatter'));
const LazyFileAttachmentSectionFormatter = /*#__PURE__*/lazy(() => import('./FileAttachmentSectionFormatter'));
const LazyImageGridSectionFormatter = /*#__PURE__*/lazy(() => import('./ImageGridSectionFormatter'));
const LazyMediaSectionV2Formatter = /*#__PURE__*/lazy(() => import('./MediaSectionV2Formatter'));
const LazyMeetingSectionFormatter = /*#__PURE__*/lazy(() => import('./MeetingSectionFormatter'));
const LazyMeetingCardSectionFormatter = /*#__PURE__*/lazy(() => import('./MeetingCardSectionFormatter'));
const LazyMarkdownWithCitationsSectionFormatter = /*#__PURE__*/lazy(() => import('./MarkdownWithCitationsSectionFormatter'));
const LazyReportSectionFormatter = /*#__PURE__*/lazy(() => import('./ReportSectionFormatter'));
const LazyNewsListCardFormatter = /*#__PURE__*/lazy(() => import('./NewsListCardFormatter'));
const LazyTimelineCardFormatter = /*#__PURE__*/lazy(() => import('./TimelineCardFormatter'));
const LazyDraftEmailSectionFormatter = /*#__PURE__*/lazy(() => import('./DraftEmailSectionFormatter'));
const LazyFilterBranchSectionFormatter = /*#__PURE__*/lazy(() => import('./FilterBranchSectionFormatter'));
const LazyDenseListSectionFormatter = /*#__PURE__*/lazy(() => import('./DenseListSectionFormatter').then(m => ({
  default: m.DenseListSectionFormatter
})));
const LazyGridSectionFormatter = /*#__PURE__*/lazy(() => import('./GridSectionFormatter'));
const LazyVisualizationSectionFormatter = /*#__PURE__*/lazy(() => import('./VisualizationSectionFormatter'));
const LazyCardWrapperSectionFormatter = /*#__PURE__*/lazy(() => import('./CardWrapperSectionFormatter'));
const LazyInlineCitationSectionFormatter = /*#__PURE__*/lazy(() => import('./InlineCitationSectionFormatter'));
const LazySourcesListSectionFormatter = /*#__PURE__*/lazy(() => import('./SourcesListSectionFormatter'));
const LazyUnstyledImageSectionFormatter = /*#__PURE__*/lazy(() => import('./UnstyledImageSectionFormatter'));
const LazyCompanyOverviewSectionFormatter = /*#__PURE__*/lazy(() => import('./CompanyOverviewSectionFormatter'));
const LazyErrorSectionFormatter = /*#__PURE__*/lazy(() => import('./ErrorSectionFormatter'));
const LazyMetricCardSectionFormatter = /*#__PURE__*/lazy(() => import('./MetricCardSectionFormatter').then(m => ({
  default: m.MetricCardSectionFormatter
})));
const LazyTabSectionFormatter = /*#__PURE__*/lazy(() => import('./TabSectionFormatter'));
const LazyChipCardFormatter = /*#__PURE__*/lazy(() => import('./ChipCardFormatter').then(m => ({
  default: m.ChipCardFormatter
})));
const LazyCrmCardSectionFormatter = /*#__PURE__*/lazy(() => import('./CrmCardSectionFormatter'));
const LazyHTMLCardSectionFormatter = /*#__PURE__*/lazy(() => import('./HTMLCardSectionFormatter').then(m => ({
  default: m.HTMLCardSectionFormatter
})));
const LazyAvatarCardSectionFormatter = /*#__PURE__*/lazy(() => import('./AvatarCardSectionFormatter').then(m => ({
  default: m.AvatarCardSectionFormatter
})));
const LazyHTMLWithChildrenSectionFormatter = /*#__PURE__*/lazy(() => import('./HTMLWithChildrenSectionFormatter'));
const LazyDataChangeSectionFormatter = /*#__PURE__*/lazy(() => import('./DataChangeSectionFormatter').then(m => ({
  default: m.DataChangeSectionFormatter
})));
const LazyAskQuestionSectionFormatter = /*#__PURE__*/lazy(() => import('./AskQuestionSectionFormatter'));
const LazySupportHandoffSectionFormatter = /*#__PURE__*/lazy(() => import('./SupportHandoffSectionFormatter'));
const LazyAssistantStatusSectionFormatter = /*#__PURE__*/lazy(() => import('./AssistantStatusSectionFormatter'));
const LazyEmailDraftCardSectionFormatter = /*#__PURE__*/lazy(() => import('./EmailDraftCardSectionFormatter').then(m => ({
  default: m.EmailDraftCardSectionFormatter
})));
const LazyComposableCardSectionFormatter = /*#__PURE__*/lazy(() => import('./composable-card'));
const LazyMeetingRecapActionsSectionFormatter = /*#__PURE__*/lazy(() => import('./MeetingRecapActionsSectionFormatter'));
const LazyArtifactCardSectionFormatter = /*#__PURE__*/lazy(() => import('./ArtifactCardSectionFormatter'));
const LazyInlineAcademyVideo = /*#__PURE__*/lazy(() => import('../../components/text/MarkdownWithCitations/InlineAcademyVideo'));
const LazyHighchartsChartSectionFormatter = /*#__PURE__*/lazy(() => import('./HighchartsChartSectionFormatter'));
const LazyScheduledPromptResponseSectionFormatter = /*#__PURE__*/lazy(() => import('./ScheduledPromptResponseSectionFormatter'));
const HighchartsChartResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HighchartsChartResponseSection';
const withSuspense = node => /*#__PURE__*/_jsx(Suspense, {
  fallback: /*#__PURE__*/_jsx(LoadingSection, {}),
  children: node
});

/**
 * Custom component registrations
 */
registerComponentRegistry(onboardingRegistryEntry, marketplaceInstallRegistry, agentHubRegistryEntry, workflowsRegistryEntry, brandedStyleGenerationRegistryEntry, lockedFeatureUpgradeRegistry, unifiedAuthBreezeRegistryEntry, dataIntegrationsBreezeRegistryEntry
// Add new registry entries above
);
export const defaultSectionRegistry = {
  [HtmlTextResponseSectionTypename]: ({
    section,
    callbacks,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyHtmlSectionFormatter, {
    section: section,
    callbacks: callbacks,
    trellisComponents: trellisComponents
  })),
  [PlainTextResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyTextWithTokensSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [UserChatResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyTextWithTokensSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [DataTableResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyDataTableSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [DataTableResponseSectionV2Typename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyDataTableSectionFormatterV2, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [MediaPreviewResponseSectionTypename]: ({
    message,
    section,
    disableActions,
    actionsTooltip,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyMediaSectionFormatter, {
    message: message,
    section: section,
    disableActions: disableActions,
    actionsTooltip: actionsTooltip,
    trellisComponents: trellisComponents
  })),
  [ThoughtResponseSectionTypename]: ({
    message,
    section,
    disableActions,
    actionsTooltip,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyThoughtSectionFormatter, {
    message: message,
    section: section,
    disableActions: disableActions,
    actionsTooltip: actionsTooltip,
    trellisComponents: trellisComponents
  })),
  [ActionsResponseSectionTypename]: ({
    section,
    disableActions,
    actionsTooltip,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyActionSectionFormatter, {
    section: section,
    disableActions: disableActions,
    actionsTooltip: actionsTooltip,
    trellisComponents: trellisComponents
  })),
  [AccordionResponseSectionTypename]: ({
    message,
    section,
    disableActions,
    actionsTooltip,
    registry,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyAccordionSectionFormatter, {
    message: message,
    section: section,
    disableActions: disableActions,
    actionsTooltip: actionsTooltip,
    registry: registry,
    trellisComponents: trellisComponents
  })),
  [CardResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyCardSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [CalendarConnectResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyCalendarConnectSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [CollaborationResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyMarkdownSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [ConfirmationResponseSectionTypename]: ({
    callbacks,
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyConfirmationSectionFormatter, {
    callbacks: callbacks,
    section: section,
    trellisComponents: trellisComponents
  })),
  [ComposableCardResponseSectionTypename]: ({
    callbacks,
    message,
    section,
    getIsUngated,
    trellisComponents
  }) => {
    if (getIsUngated(gate('BreezeAssistant:Tools:VisualRendering'))) {
      return withSuspense( /*#__PURE__*/_jsx(LazyComposableCardSectionFormatter, {
        callbacks: callbacks,
        message: message,
        section: section,
        trellisComponents: trellisComponents
      }));
    }
    return null;
  },
  [FileAttachmentResponseSectionTypename]: ({
    message,
    section,
    trellisComponents
  }) => {
    var _message$dynamicSecti, _message$dynamicSecti2;
    return withSuspense( /*#__PURE__*/_jsx(LazyFileAttachmentSectionFormatter, {
      section: section,
      allSections: [...message.sections, ...((_message$dynamicSecti = (_message$dynamicSecti2 = message.dynamicSectionContainers) === null || _message$dynamicSecti2 === void 0 ? void 0 : _message$dynamicSecti2.map(c => c.responseSection)) !== null && _message$dynamicSecti !== void 0 ? _message$dynamicSecti : [])],
      trellisComponents: trellisComponents
    }));
  },
  [ImageGridResponseSectionTypename]: ({
    callbacks,
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyImageGridSectionFormatter, {
    section: section,
    callbacks: callbacks,
    trellisComponents: trellisComponents
  })),
  [MediaPreviewResponseSectionV2Typename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyMediaSectionV2Formatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [MeetingResponseSectionTypename]: ({
    section,
    getIsUngated,
    callbacks,
    trellisComponents
  }) => {
    if (getIsUngated(gate('BreezeAssistant:Experience:MeetingsBedrock'))) {
      return withSuspense( /*#__PURE__*/_jsx(LazyMeetingCardSectionFormatter, {
        section: section,
        callbacks: callbacks,
        trellisComponents: trellisComponents
      }));
    }
    if (getIsUngated(gate('BreezeAssistant:Tools:Meeting'))) {
      return withSuspense( /*#__PURE__*/_jsx(LazyMeetingSectionFormatter, {
        section: section,
        callbacks: callbacks,
        trellisComponents: trellisComponents
      }));
    }
    return withSuspense( /*#__PURE__*/_jsx(LazyErrorSectionFormatter, {
      section: section,
      trellisComponents: trellisComponents
    }));
  },
  [MeetingRecapActionDataResponseSectionTypename]: ({
    section,
    callbacks,
    getIsUngated,
    trellisComponents
  }) => {
    if (!getIsUngated(gate('BreezeAssistant:MeetingActionData'))) {
      return null;
    }
    return withSuspense( /*#__PURE__*/_jsx(LazyMeetingRecapActionsSectionFormatter, {
      section: section,
      callbacks: callbacks,
      trellisComponents: trellisComponents
    }));
  },
  [MeetingCardResponseSectionTypename]: ({
    section,
    callbacks,
    trellisComponents
  }) => {
    return withSuspense( /*#__PURE__*/_jsx(LazyMeetingCardSectionFormatter, {
      section: section,
      callbacks: callbacks,
      meetingCardSection: section,
      trellisComponents: trellisComponents
    }));
  },
  [LlmResponseSectionTypename]: ({
    message,
    section,
    callbacks,
    isStreaming,
    showLoadingDotWhenStreaming,
    registry,
    isInCanvasView,
    disableArtifacts,
    artifactsTooltip,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyMarkdownWithCitationsSectionFormatter, {
    message: message,
    section: section,
    callbacks: callbacks,
    isStreaming: isStreaming,
    showLoadingDotWhenStreaming: showLoadingDotWhenStreaming,
    registry: registry,
    isInCanvasView: isInCanvasView,
    disableArtifacts: disableArtifacts,
    artifactsTooltip: artifactsTooltip,
    trellisComponents: trellisComponents
  })),
  [ReportResponseSectionTypename]: props => {
    const external = resolveExternalSectionFormatter(ReportResponseSectionTypename);
    if (external) {
      return external(props);
    }
    const {
      section,
      message,
      trellisComponents
    } = props;
    return withSuspense( /*#__PURE__*/_jsx(LazyReportSectionFormatter, {
      section: section,
      message: message,
      trellisComponents: trellisComponents
    }));
  },
  [FilterBranchResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyFilterBranchSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [DenseListResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyDenseListSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [GridResponseSectionTypename]: ({
    message,
    section,
    registry,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyGridSectionFormatter, {
    message: message,
    section: section,
    registry: registry,
    trellisComponents: trellisComponents
  })),
  [VisualizationResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyVisualizationSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [CardWrapperResponseSectionTypename]: ({
    message,
    section,
    registry,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyCardWrapperSectionFormatter, {
    message: message,
    section: section,
    registry: registry,
    trellisComponents: trellisComponents
  })),
  [InlineCitationResponseSectionTypename]: ({
    section,
    callbacks,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyInlineCitationSectionFormatter, {
    section: section,
    callbacks: callbacks,
    trellisComponents: trellisComponents
  })),
  [SourcesListResponseSectionTypename]: ({
    section,
    callbacks,
    message,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazySourcesListSectionFormatter, {
    section: section,
    callbacks: callbacks,
    message: message,
    trellisComponents: trellisComponents
  })),
  [UnstyledImageResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyUnstyledImageSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [CompanyOverviewResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyCompanyOverviewSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [MetricCardResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyMetricCardSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [TabResponseSectionTypename]: ({
    message,
    section,
    registry,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyTabSectionFormatter, {
    message: message,
    section: section,
    registry: registry,
    trellisComponents: trellisComponents
  })),
  [ChipsCardResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyChipCardFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [CrmCardResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyCrmCardSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [HtmlCardResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyHTMLCardSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [AvatarCardResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyAvatarCardSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [NewsListCardResponseSectionTypename]: ({
    section,
    callbacks,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyNewsListCardFormatter, {
    section: section,
    callbacks: callbacks,
    trellisComponents: trellisComponents
  })),
  [TimelineCardResponseSectionTypename]: ({
    section,
    callbacks,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyTimelineCardFormatter, {
    section: section,
    callbacks: callbacks,
    trellisComponents: trellisComponents
  })),
  [HtmlWithChildrenResponseSectionTypename]: ({
    message,
    section,
    registry,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyHTMLWithChildrenSectionFormatter, {
    message: message,
    section: section,
    registry: registry,
    trellisComponents: trellisComponents
  })),
  [DraftEmailResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyDraftEmailSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [EmailDraftCardResponseSectionTypename]: ({
    section,
    callbacks,
    isInCanvasView,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyEmailDraftCardSectionFormatter, {
    section: section,
    callbacks: callbacks,
    isInCanvasView: isInCanvasView,
    trellisComponents: trellisComponents
  })),
  [DataChangeResponseSectionTypename]: ({
    section,
    callbacks,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyDataChangeSectionFormatter, {
    section: section,
    callbacks: callbacks,
    trellisComponents: trellisComponents
  })),
  [HighchartsChartResponseSectionTypename]: ({
    section,
    getIsUngated,
    trellisComponents
  }) => {
    var _getIsUngated;
    return withSuspense( /*#__PURE__*/_jsx(LazyHighchartsChartSectionFormatter, {
      section: section,
      showChartTypeToggles: (_getIsUngated = getIsUngated(gate('BreezeCoreExperience:ChartTypeToggles'))) !== null && _getIsUngated !== void 0 ? _getIsUngated : false,
      trellisComponents: trellisComponents
    }));
  },
  [ContextItemResponseSectionTypename]: () => null,
  [AskQuestionResponseSectionTypename]: ({
    section,
    message,
    callbacks,
    disableActions,
    trellisComponents
  }) => {
    var _message$dynamicSecti3, _message$dynamicSecti4;
    return withSuspense( /*#__PURE__*/_jsx(LazyAskQuestionSectionFormatter, {
      section: section,
      allSections: [...message.sections, ...((_message$dynamicSecti3 = (_message$dynamicSecti4 = message.dynamicSectionContainers) === null || _message$dynamicSecti4 === void 0 ? void 0 : _message$dynamicSecti4.map(c => c.responseSection)) !== null && _message$dynamicSecti3 !== void 0 ? _message$dynamicSecti3 : [])],
      callbacks: callbacks,
      disableActions: disableActions,
      trellisComponents: trellisComponents
    }));
  },
  [SupportHandoffResponseSectionTypename]: ({
    section,
    callbacks,
    message,
    getIsUngated,
    trellisComponents
  }) => {
    if (!getIsUngated(gate('BreezeAssistant:Tools:SupportHandoff'))) {
      return null;
    }
    const isUngatedForChatSupportHandoff = getIsUngated(gate('BreezeAssistant:ChatSupportHandoff'));
    return withSuspense( /*#__PURE__*/_jsx(LazySupportHandoffSectionFormatter, {
      section: section,
      callbacks: callbacks,
      portalId: message.portalId,
      isUngatedForChatSupportHandoff: isUngatedForChatSupportHandoff,
      trellisComponents: trellisComponents
    }));
  },
  [StepListResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyAssistantStatusSectionFormatter, {
    section: section,
    trellisComponents: trellisComponents
  })),
  [ArtifactCardResponseSectionTypename]: ({
    section,
    callbacks,
    isInCanvasView,
    disableArtifacts,
    artifactsTooltip,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyArtifactCardSectionFormatter, {
    section: section,
    callbacks: callbacks,
    isInCanvasView: isInCanvasView,
    disableArtifacts: disableArtifacts,
    artifactsTooltip: artifactsTooltip,
    trellisComponents: trellisComponents
  })),
  [InlineAcademyVideoResponseSectionTypename]: ({
    section
  }) => withSuspense( /*#__PURE__*/_jsx(LazyInlineAcademyVideo, {
    section: section
  })),
  [MeetingPrepActionDataResponseSectionTypename]: () => null,
  [CustomComponentResponseSectionTypename]: ({
    section,
    trellisComponents
  }) => {
    var _s$componentArgs;
    const s = section;
    const Component = resolveComponent(s.namespace, s.customComponentType);
    if (!Component) {
      return /*#__PURE__*/_jsx(CustomComponentFallback, {
        text: s.fallbackText,
        warnNamespace: s.namespace,
        warnComponentType: s.customComponentType,
        trellisComponents: trellisComponents
      });
    }
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      ErrorContent: /*#__PURE__*/_jsx(CustomComponentFallback, {
        text: s.fallbackText,
        trellisComponents: trellisComponents
      }),
      name: `CustomComponent-${s.namespace}-${s.customComponentType}`,
      children: /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(LoadingSection, {}),
        children: /*#__PURE__*/_jsx(Component, {
          args: convertFieldValueAvroToJson({
            __typename: 'com.hubspot.chirp.ext.models.MapFieldValue',
            value: (_s$componentArgs = s.componentArgs) !== null && _s$componentArgs !== void 0 ? _s$componentArgs : {}
          })
        })
      })
    });
  },
  [ScheduledPromptResponseSectionTypename]: ({
    section,
    callbacks,
    trellisComponents
  }) => withSuspense( /*#__PURE__*/_jsx(LazyScheduledPromptResponseSectionFormatter, {
    section: section,
    callbacks: callbacks,
    trellisComponents: trellisComponents
  }))
};